import { useRef } from 'react'

import type { AgGridReact } from 'ag-grid-react'
import type { ReactElement } from 'react'

import columns from './columns'

import ContentLayout from '~/components/ContentLayout'
import Layout from '~/components/Layouts/Layout'
import Section from '~/components/Section'
import TableWrapper from '~/components/Tables/TableWrapper'
import ViewTitle from '~/components/ViewTitle'
import useDocumentTitle from '~/hooks/useDocumentTitle'
import { useCompaniesListQuery } from '~/queries/clusters'

import './styles.scss'

const ENTRIES_NAME = 'companies'

const CompetitorsCompanies = (): ReactElement => {
  /** Local state */

  const gridRef = useRef<AgGridReact>(null)

  const tableRef = useRef<HTMLDivElement>(null)

  /** Queries & Mutations */

  const { data: companiesList } = useCompaniesListQuery({ size: 1000 })

  /** Effects */

  useDocumentTitle('Competitors - Companies')

  return (
    <>
      <ViewTitle className="layout-view-title top-zero">Companies</ViewTitle>
      <Layout className="companies-view" withPadding>
        <ContentLayout>
          <Section className="section">
            <TableWrapper
              className="companies-table with-min-height"
              columnDefs={columns}
              entriesName={ENTRIES_NAME}
              ref={gridRef}
              rowData={companiesList?.data || []}
              rowStyle={{ cursor: 'default' }}
              tableRef={tableRef}
              withPagination={false}
              withSearchBar
            />
          </Section>
        </ContentLayout>
      </Layout>
    </>
  )
}

export default CompetitorsCompanies
